module.exports = __webpack_public_path__ + "static/media/lc.1f8cb283.svg";